// extracted by mini-css-extract-plugin
export default {"expandable":"Expandable_expandable__xSGNZ","openExpandableTitle":"Expandable_openExpandableTitle__mmUj8","expandableOpenContent":"Expandable_expandableOpenContent__7h8VF"};